import React from 'react';
import { motion } from 'framer-motion';

const cardsData = [
    {
        id: 1,
        title: "Employee Assistance Program (EAP)",
        description: "At Mobikode, we know that life can sometimes feel overwhelming, and having the right support makes all the difference. Our Employee Assistance Program (EAP) offers confidential, professional help for personal, emotional, relationship, legal, and financial matters. Whether you're facing a challenge or simply need someone to talk to, we're here to support you every step of the way. ",
        image: "/assets/benefits/item1.png",
        borderColor: "#01386A"
    },
    {
        id: 2,
        title: "Apps & Tools",
        description: "At Mobikode, your well-being comes first. Access helpful wellness apps and tools that support your mental health, encourage balance, reduce everyday stress, and help you feel your best at work and beyond.",
        image: "/assets/benefits/item2.png",
        borderColor: "#01386A"
    },
    {
        id: 3,
        title: "Mental Health Ally Network",
        description: "At Mobikode, we care about the people behind the work. Our Mental Health Ally Network offers a safe, supportive space to connect, talk openly, seek guidance, and feel supported through life’s challenges.",
        image: "/assets/benefits/item3.png",
        borderColor: "#01386A"
    }
];

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.15 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const MentalWellbeingSection = () => {
    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-[32px] md:gap-[50px] lg:gap-[100px]">
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        variants={{
                            lg: { initial: { opacity: 0, x: -30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="flex flex-col lg:max-w-[500px] lg:sticky lg:top-[100px] h-fit"
                    >
                        <h2 className="text-[20px] md:text-[30px] font-sora font-[600] text-[#01386A] leading-[1.2] mb-[12px] md:mb-[20px]">
                            Your mental well-being
                        </h2>
                        <p className="text-[14px] lg:text-[16px] font-[500] font-graphik text-[#49577A] leading-[1.6]">
                            We believe you're more than your job title. That’s why we create an environment where you feel valued, supported, and empowered to thrive, both at work and in life.
                        </p>
                    </motion.div>

                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        className="flex flex-col gap-[20px] md:gap-[30px]"
                    >
                        {cardsData.map((card) => (
                            <motion.div
                                key={card.id}
                                variants={itemVariants}
                                className="relative bg-white border border-[#01386A45] p-[20px] sm:p-[30px] shadow-[0_4px_20px_rgba(0,0,0,0.03)] md:hover:-translate-y-1 md:hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] transition-all duration-300 overflow-hidden cursor-default group"
                            >
                                <div
                                    className="absolute bottom-0 left-0 h-[4px]"
                                    style={{ backgroundColor: card.borderColor, width: '100%' }}
                                />

                                <div
                                    className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#F97316] transition-all duration-500 ease-out group-hover:w-full z-10"
                                />
                                <div className="flex flex-col sm:flex-row gap-[16px] sm:gap-[30px] pb-[16px] sm:pb-[26px] w-full">
                                    <div className="w-full sm:max-w-[258px] h-[140px] sm:h-[120px] overflow-hidden shrink-0 rounded-sm">
                                        <img
                                            src={card.image}
                                            alt={card.title}
                                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                        />
                                    </div>
                                    <h4 className="text-[16px] sm:text-[20px] font-[600] font-sora text-[#01386A] sm:mb-[10px]">
                                        {card.title}
                                    </h4>
                                </div>

                                <div>
                                    <p className="text-[14px] sm:text-[16px] font-[500] font-graphik text-[#49577A] leading-[1.6]">
                                        {card.description}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default MentalWellbeingSection;